import * as React from 'react';
import { useEffect } from 'react';
import { DeprecatedOrdersPage } from 'src/scenes/letseatmanager/orders/DeprecatedOrdersPage';
import { OrdersPage } from 'src/scenes/letseatmanager/OrdersPage';
import { useLoadPosMenus } from 'src/services/menu/useLoadPosMenus';
import { useUserType } from 'src/services/restaurant/useUserType';
import { useSelector } from 'src/utils/react/useSelector';
import { isBrandUser } from 'src/utils/user/isBrandUser';

export function TemporalOrdersPage(): React.ReactElement {
    const userType = useUserType();
    const loadPosMenus = useLoadPosMenus();

    const posMenu = useSelector((state) => state.pos.posMenu);
    const posEnabled = useSelector((state) => state.app.restaurant?.posEnabled);
    const brandOpened = useSelector((state) => state.app.brandOpened);

    const newOrdersPageEnabled = useSelector((state) => state.app.restaurant.newOrdersPageEnabled);
    const restaurants = useSelector((state) => state.app.restaurants);

    const someRestaurantHasNewOrdersPageEnabled = restaurants.some((restaurant) => restaurant.newOrdersPageEnabled);
    const renderNewOrdersPageEnabled = (someRestaurantHasNewOrdersPageEnabled && isBrandUser(userType)) || newOrdersPageEnabled;

    useEffect(() => {
        if (!posMenu?.menus?.length && posEnabled && !brandOpened) loadPosMenus();
    }, [posEnabled, brandOpened]);

    if (renderNewOrdersPageEnabled) return <OrdersPage />;

    return <DeprecatedOrdersPage />;
}
